export var IssueStatus;
(function (IssueStatus) {
    IssueStatus["TODO"] = "TODO";
    IssueStatus["IN_PROGRESS"] = "IN_PROGRESS";
    IssueStatus["COMPLETED"] = "DONE";
})(IssueStatus || (IssueStatus = {}));
export var IssueType;
(function (IssueType) {
    IssueType["GOAL"] = "Goal";
    IssueType["TASK"] = "Task";
})(IssueType || (IssueType = {}));
export var IssueVisibility;
(function (IssueVisibility) {
    IssueVisibility["PRIVATE"] = "private";
    IssueVisibility["PUBLIC"] = "public";
})(IssueVisibility || (IssueVisibility = {}));
export var ExternalMetadataProvider;
(function (ExternalMetadataProvider) {
    ExternalMetadataProvider["JIRA"] = "jira";
    ExternalMetadataProvider["MONDAY"] = "monday";
    ExternalMetadataProvider["MS_PROJECT"] = "ms_project";
    ExternalMetadataProvider["DEBRIEF"] = "debrief";
    ExternalMetadataProvider["FEEDBACK"] = "feedback";
    ExternalMetadataProvider["NATIVE"] = "native";
    ExternalMetadataProvider["SHAREPOINT"] = "sharepoint";
    ExternalMetadataProvider["DYNAMICS_CRM"] = "dynamics_crm";
})(ExternalMetadataProvider || (ExternalMetadataProvider = {}));
